import { PDFViewer } from "@react-pdf/renderer";
import { DocuPdf } from "../pdf/DocuPdf";
import { Spinner } from "../ui/Spinner";
import { useEffect, useState } from "react";
import { Report } from "../../interfaces/intakes.reports";
import { useCharts } from "../../hooks/useCharts";
import { useNoIndex } from "../../hooks/useNoIndex";

export const ViewLivePdf = () => {

    useNoIndex();

    const [data, setData] = useState<Report | null>(null);

    useEffect(() => {
        const storedData = localStorage.getItem('pdfData');
        if (storedData) {
            setData(JSON.parse(storedData));
        }
    }, []);

    // --------------- TODA ESTA PARTE EN UN HOOK ------------------

    const { charts, ready, DonutsRenderer } = useCharts(data);

    // ---------------------------------------------------------

    return (
        <>
            { data && DonutsRenderer}

            {
                (data && ready)
                    ?
                    <PDFViewer style={{ minWidth: "100%", height: "100vh" }}>
                        <DocuPdf allData={data} charts={charts} />
                    </PDFViewer>
                    :
                    <Spinner />
            }
        </>
    )
}